var lf,
LayoutFilter = {
	settings: {
		mainWindow: jQuery(window),
		menuToggle: '',
		filterGroups: jQuery('.filter.active'),
		textFilters: jQuery('.text-filter'),
		selectFilters: jQuery('.select-filter'),
		noResults: jQuery('.layout.listing li.no-results'),
	},
	init: function() {
		lf = this.settings;
		this.bindUIActions();
        console.log('LayoutFilter loaded!');
	},
	bindUIActions: function() {
		lf.noResults.hide();
		lf.filterGroups.each(function(){
			var filterGroup = jQuery(this);

            if(filterGroup.find('.text-filter').length > 0) {
				var textFilter = filterGroup.find('.text-filter');
				textFilter.keydown(function(evt){
					if(evt.which == 13){
						evt.preventDefault();
					}
    			});
				textFilter.keyup(function(evt){
					evt.preventDefault();
					LayoutFilter.filterData(filterGroup);
    			});

			}
			if(filterGroup.find('.select-filter').length > 0) {
				var selectFilter = filterGroup.find('.select-filter');
				selectFilter.change(function(){
					LayoutFilter.filterData(filterGroup);
    			});
			}
		});
	},
	filterData: function(ele){
        lf.noResults.hide();
		// ele returns jquery object of filter div that contains all filter fields
		var textValue = ele.find('.text-filter').val();
		var selectActive = false;
		var selectElement = ele.find('.select-filter');
		var selectValue = '';
		var count = 0;

		// if the select element is present
		if(selectElement.length > 0){
			var selectTaxonomy = selectElement.data('taxonomy');
			if(selectElement.val() != 'all'){
				selectActive = true;
				selectValue = selectElement.val();

			}

		}

		// ele.next().find('.no-results').hide();
		// Loop through the list elements
		ele.next().find('li').each(function(){
			var thisItem = jQuery(this);
			var thisItemTag = thisItem.data('bdas_service_tags'),
					thisItemTag = "" + thisItemTag;
			var thisItemData = thisItem.data(selectTaxonomy),
				thisItemData = "" + thisItemData;

			if(selectActive){
				// If the list item contains the text phrase show item and increase the count by 1
				if (
					(thisItem.text().search(new RegExp(textValue, "i")) >= 0 && thisItemData.search(new RegExp(selectValue, "i")) >= 0) ||
					(thisItemTag.search(new RegExp(textValue, "i")) >= 0 && thisItemData.search(new RegExp(selectValue, "i")) >= 0)
				) {
					thisItem.show();
					count++;
					lf.noResults.hide();

				} else { // Hide the list item if the phrase doesn't match
					thisItem.fadeOut();
					console.log('select active no match');
				}
			} else {
				// If the list item contains the text phrase show item and increase the count by 1
				if (
					thisItem.text().search(new RegExp(textValue, "i")) >= 0 ||
					thisItemTag.search(new RegExp(textValue, "i")) >= 0
				) {
					thisItem.show();
					count++;
          lf.noResults.hide();

				} else {// Hide the list item if the phrase does not match
					thisItem.fadeOut();
				}
			}


			if (thisItemTag.search(new RegExp(textValue, "i")) < 0) {
				console.log('no-match');
			} else {
				console.log('match');
			}

		});
		if(count === 0){
			// ele.next().find('.no-results').show();
            lf.noResults.show();
		}
	}
}
